import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    thead: {
      "& th": {
        whiteSpace: "nowrap",
        wordBreak: "keep-all",
        borderLeft: "1px solid rgba(198, 209, 221)",
        borderTop: "1px solid #CFCFCF",
      },
      "& th:nth-child(2)": {
        width: "45px",
      },
      "& th:nth-child(3)": {
        width: "25%",
      },
      "& th:nth-child(4)": {
        width: "90px",
      },
      "& th:nth-child(5)": {
        width: "90px",
      },
      "& th:nth-child(6)": {
        width: "20%",
      },
      "& th:nth-child(7)": {
        width: "80px",
      },
      "& th:nth-child(8)": {
        width: "80px",
      },
      "& th:nth-child(9)": {
        width: "150px",
      },
      "& th:last-child": {
        borderRight: "1px solid rgba(198, 209, 221)",
        width: "60px",
      },
      "& .MuiTableCell-paddingCheckbox": {
        width: "40px",
        paddingTop: "3.5px",
        paddingBottom: "2px",
        paddingLeft: "10px",
        paddingRight: "10px",
      },
    },
    tbody: {
      "& td:not(:first-child)": {
        borderLeft: "1px solid rgba(198, 209, 221)",
      },
    },
    tableRow: {
      "& td:not(:first-child)": {
        borderLeft: "1px solid rgba(198, 209, 221)",
      },
      "& td": {
        paddingTop: "3.5px",
        paddingBottom: "2px",
        paddingLeft: "10px",
        paddingRight: "10px",
      },
    },
    tableRowRed: {
      backgroundColor: "rgba(230, 0, 18, 0.6);",
    },
    tableRowGreen: {
      backgroundColor: "#E2EFDA",
    },
    tableRowGray: {
      backgroundColor: "rgba(198, 209, 221)",
    },
    tableRowYellow: {
      backgroundColor: "rgba(246, 172, 25, 0.6);",
    },
    tableRowHighlight: {
      backgroundColor: "#F9FF85",
    },
    tableRowHeader: {
      "& .MuiTableCell-head": {
        // width: "40px",
        width: "20%",
        backgroundColor: "rgba(240, 242, 244)",
      },
    },
    cellCheckbox: {
      width: "40px !important",
    },
    visuallyHidden: {
      border: 0,
      clip: "rect(0 0 0 0)",
      height: 1,
      margin: -1,
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      top: 20,
      width: 1,
    },
    nowrap: {
      whiteSpace: "nowrap",
      wordBreak: "keep-all",
      borderLeft: "1px solid rgba(198, 209, 221)",
    },
    leftNowrap: {
      borderLeft: "1px solid rgba(198, 209, 221)",
      width: "40px",
    },
    rightNowrap: {
      borderRight: "1px solid rgba(198, 209, 221)",
      whiteSpace: "pre",
    },
    nowrapTechnician: {
      whiteSpace: "nowrap",
      wordBreak: "keep-all",
      width: "40px",
    },
    groupContainer: {
      maxHeight: 650,
    },
    tfoot: {
      "& td": {
        background: "rgba(240, 242, 244)",
        whiteSpace: "nowrap",
        wordBreak: "keep-all",
        position: "sticky",
        bottom: 0,
        zIndex: 3,
        borderTop: "1px solid rgba(198, 209, 221)",
      },
      "& td:not(:first-child)": {
        borderLeft: "1px solid rgba(198, 209, 221)",
      },
    },
    claimListContainer: {
      maxHeight: 560,
     // maxHeight: 510,
    },
    claimPaper: {
      width: "100%",
    },
  })
);
